import { useState, useCallback, useEffect, useMemo } from 'react'
import { getKyousouApiClient } from '../services/network'
import {
  EnterpriseMatchingStatus,
  EnterpriseMatchingStatusValue,
} from '../enums/EnterpriseMatchingStatus'

/**
 * 特定の企業とのマッチング状況を取得するフック
 * @returns
 */
export const useEnterpriseMatchingStatus = (
  enterpriseId: string | undefined
): {
  status: EnterpriseMatchingStatusValue
  loading: boolean
  confirm: () => void
} => {
  const [status, setStatus] = useState<EnterpriseMatchingStatusValue>(
    EnterpriseMatchingStatus.NONE
  )
  const [isLoading, setIsLoading] = useState(true)
  const apiClient = useMemo(() => getKyousouApiClient(), [])

  const confirm = useCallback(async () => {
    if (!enterpriseId) {
      // 企業IDがない場合はローディング状態を維持
      setIsLoading(true)
      return
    }
    try {
      setIsLoading(true)
      const response =
        await apiClient.enterprise.matchingRequestStatusList(enterpriseId)

      setStatus(response.data.status)
    } catch (error) {
      console.error('企業検索エラー:', error)
    } finally {
      setIsLoading(false)
    }
  }, [enterpriseId, apiClient])

  useEffect(() => {
    confirm()
  }, [enterpriseId])

  return {
    status,
    loading: isLoading,
    confirm,
  }
}
